export function copyToClipboard(value: string) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(value);
  } else {
    // fallback for older browsers
    const textarea = document.createElement("textarea");
    textarea.value = value;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  }
}
